import { createContext, useContext, useState, ReactNode } from 'react';

interface ManualPasteContextType {
  showManualPasteDialog: (callback: (text: string) => void) => void;
  isDialogOpen: boolean;
  closeDialog: () => void;
  handlePaste: (text: string) => void;
}

const ManualPasteContext = createContext<ManualPasteContextType | undefined>(undefined);

export function ManualPasteProvider({ children }: { children: ReactNode }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [pasteCallback, setPasteCallback] = useState<((text: string) => void) | null>(null);

  const showManualPasteDialog = (callback: (text: string) => void) => {
    setPasteCallback(() => callback);
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setPasteCallback(null);
  };

  const handlePaste = (text: string) => {
    if (pasteCallback) {
      pasteCallback(text);
    }
    closeDialog();
  };

  return (
    <ManualPasteContext.Provider
      value={{ showManualPasteDialog, isDialogOpen, closeDialog, handlePaste }}
    >
      {children}
    </ManualPasteContext.Provider>
  );
}

export function useManualPaste() {
  const context = useContext(ManualPasteContext);
  if (!context) {
    throw new Error('useManualPaste must be used within ManualPasteProvider');
  }
  return context;
}
